
import { Options, Vue } from 'vue-class-component';
import HelloWorld from '../../components/HelloWorld.vue';
import { DataUtil } from '@/util/DataUtil';
import { userPrivacyConfig } from "@/config/template_new_user_privacy";

@Options({
    components: {
        HelloWorld,
    }
})
export default class App extends Vue {

    private temp: string = userPrivacyConfig.template_new_protocol_20230926;

    private config: TemplateInterface = {
        productName: '恐龙多多',
        companyFullName: '海南杉木网络技术有限公司',
        companyShortName: '海南杉木',
        officialWebsite: 'http://www.hnshamu.com/',
        mail: "2557621062@qq.com",
        cashConfig: ``

    };

    mounted() {
        this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
}
